import Router from 'vue-router';
import NProgress from 'nprogress';
import { AuthHeader, UnsignedHeader } from '@/components/Header';
import { isAuthenticated } from '@/assets/js/utils/auth';
import Store from '@/store';

const BASE = window.location.pathname.match(/(.*\/client)\/?/);

/**
 * Ошибка загрузки чанка
 * Выключить глобальный лоадер и установить в стор флаг
 * о глобальной ошибке
 */
const onChunkLoadError = () => {
  NProgress.done();
  Store.dispatch('setGlobalError', true);
};

/**
 * Если по какой-то причине есть флаг об ошибке
 * и отработал загрузчик чанка - снять ошибку
 * @param data
 * @return {*}
 */
const onChunkLoadSucces = data => {
  NProgress.done();
  if (Store.getters.hasGlobalError) {
    Store.dispatch('setGlobalError', false);
  }
  Store.dispatch('setOperationError', '');
  return data;
};

const router = new Router({
  mode: 'history',
  base: BASE ? BASE[1] : '/',
  routes: [
    {
      path: '/bookings',
      name: 'bookings',
      components: {
        default: () => {
          NProgress.start();
          return import('@/views/BookingList/BookingList.vue')
            .then(onChunkLoadSucces)
            .catch(onChunkLoadError);
        },
        header: AuthHeader,
      },
    },
    {
      path: '/bookings/:id',
      name: 'bookingDetails',
      components: {
        default: () => {
          NProgress.start();
          return import('@/views/BookingDetails/BookingDetails.vue')
            .then(onChunkLoadSucces)
            .catch(onChunkLoadError);
        },
        header: AuthHeader,
      },
    },
    {
      path: '/balance',
      name: 'balance',
      components: {
        default: () => {
          NProgress.start();
          return import('@/views/Balance/Balance.vue')
            .then(onChunkLoadSucces)
            .catch(onChunkLoadError);
        },
        header: AuthHeader,
      },
    },
    {
      path: '/extra-payments',
      name: 'extraPayments',
      components: {
        default: () => {
          NProgress.start();
          return import('@/views/ExtraPayment/ExtraPayment.vue')
            .then(onChunkLoadSucces)
            .catch(onChunkLoadError);
        },
        header: AuthHeader,
      },
      beforeEnter: (to, from, next) => {
        if (to.query.paymentResult) {
          Store.commit('$_extraPayment/SET_PAYMENT_RESULT', to.query.paymentResult);
          next({ replace: true, name: 'extraPayments' });

          return;
        }

        next();
      },
    },
    {
      path: '/profile',
      name: 'profile',
      components: {
        default: () => {
          NProgress.start();
          return import('@/views/Profile/ProfilePage.vue')
            .then(onChunkLoadSucces)
            .catch(onChunkLoadError);
        },
        header: AuthHeader,
      },
    },
    {
      path: '/login',
      name: 'login',
      components: {
        default: () => import('@/views/Auth/Login.vue'),
        header: UnsignedHeader,
      },
    },
    {
      path: '/restore',
      name: 'restore',
      components: {
        default: () => import('@/views/Auth/Restore.vue'),
        header: UnsignedHeader,
      },
    },
    {
      path: '/set-password',
      name: 'setPassword',
      components: {
        default: () => import('@/views/Auth/SetPassword.vue'),
        header: UnsignedHeader,
      },
    },
    { path: '*', redirect: '/bookings' },
  ],
});

export function isOpenRouter(name) {
  const openRoutes = ['login', 'restore', 'register', 'setPassword'];
  return openRoutes.includes(name);
}

router.beforeEach((to, from, next) => {
  const isAuth = isAuthenticated();
  if (!isOpenRouter(to.name) && !isAuth) {
    next({
      path: '/login',
      query: { redirect: to.fullPath },
    });
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js